import { useState } from "react";
import axios from "axios";

export default function useAdminStats({ apiBaseUrl }) {
  const [dashboardStats, setDashboardStats] = useState(null);
  const [recentOrders, setRecentOrders] = useState([]);
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedCustomerStats, setSelectedCustomerStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);

  const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("token")}`
  });

  const fetchDashboardStats = async () => {
    setStatsLoading(true);
    try {
      const response = await axios.get(`${apiBaseUrl}/admin/stats/dashboard`, {
        headers: authHeaders()
      });
      setDashboardStats(response.data);
    } catch (error) {
      console.error("获取统计数据失败:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  const fetchRecentOrders = async () => {
    setStatsLoading(true);
    try {
      const response = await axios.get(`${apiBaseUrl}/admin/stats/recent-orders?limit=15`, {
        headers: authHeaders()
      });
      setRecentOrders(response.data);
    } catch (error) {
      console.error("获取最近订单失败:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  const fetchMonthlyTrend = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/admin/stats/monthly-trend?months=12`, {
        headers: authHeaders()
      });
      setMonthlyTrend(response.data);
    } catch (error) {
      console.error("获取月度趋势失败:", error);
    }
  };

  const fetchCustomerStats = async (customerName) => {
    try {
      const response = await axios.get(`${apiBaseUrl}/admin/stats/customer/${encodeURIComponent(customerName)}`, {
        headers: authHeaders()
      });
      setSelectedCustomerStats(response.data);
    } catch (error) {
      console.error("获取客户统计失败:", error);
    }
  };

  const closeCustomerStats = () => {
    setSelectedCustomerStats(null);
  };

  return {
    closeCustomerStats,
    dashboardStats,
    fetchCustomerStats,
    fetchDashboardStats,
    fetchMonthlyTrend,
    fetchRecentOrders,
    monthlyTrend,
    recentOrders,
    selectedCustomerStats,
    statsLoading,
  };
}
